import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaBars,
  FaTimes,
  FaUserCircle,
  FaSignOutAlt,
  FaHome,
  FaShoppingCart,
  FaChevronDown,
  FaUser,
  FaChartLine
} from 'react-icons/fa';
import { GiMedicinePills } from 'react-icons/gi';
import { database } from '../firebase';
import { ref, onValue } from 'firebase/database';
import logo from '../asstes/logo.png'

const AdminNavbar = ({ toggleSidebar, isSidebarOpen }) => {
  const navigate = useNavigate();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [adminData, setAdminData] = useState({
    email: '',
    mobileNumber: '',
    role: 'Super Admin'
  });
  const [loading, setLoading] = useState(true);

  const handleLogout = () => {
    // Add logout logic here
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  // Fetch admin data from Firebase
  useEffect(() => {
    const adminRef = ref(database, 'Dr/admin');
    
    const unsubscribe = onValue(adminRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setAdminData({
          email: data.email || 'admin@Anusaya.com',
          mobileNumber: data.mobilenumber || 'Not provided',
          role: data.role || 'Super Admin'
        });
      }
      setLoading(false);
    }, (error) => {
      console.error('Error fetching admin data:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.profile-dropdown') && isProfileOpen) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isProfileOpen]);

  return (
    <nav className="bg-gradient-to-r from-teal-800 to-emerald-800 text-white shadow-lg sticky top-0 z-40">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* LEFT SIDE */}
          <div className="flex items-center space-x-4">
            {/* Sidebar Toggle Button */}
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-lg hover:bg-teal-700 transition-colors lg:hidden"
              aria-label="Toggle sidebar"
            >
              {isSidebarOpen ? (
                <FaTimes className="text-xl" />
              ) : (
                <FaBars className="text-xl" />
              )}
            </button>

            {/* Logo and Title */}
            <Link to="/admin/dashboard" className="flex items-center space-x-3 group">
              <div className="bg-white p-2 rounded-xl shadow-lg">
                <img src={logo} alt="Anusaya Admin Logo" className="h-10 w-10 object-contain" />
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold tracking-tight group-hover:text-teal-200 transition-colors">
                  Anusaya Admin
                </h1>
                <p className="text-xs text-teal-300">Healthcare Management System</p>
              </div>
              <div className="sm:hidden">
                <h1 className="text-lg font-bold">Admin Panel</h1>
              </div>
            </Link>

            {/* Dashboard Quick Link - Desktop */}
            <Link
              to="/admin/dashboard"
              className="hidden md:flex items-center space-x-2 px-4 py-2 bg-teal-700/50 hover:bg-teal-700 rounded-lg transition-colors"
            >
              <FaChartLine />
              <span className="text-sm font-medium">Dashboard</span>
            </Link>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex items-center space-x-4">
            {/* Admin Profile Dropdown */}
            <div className="relative profile-dropdown">
              <button
                onClick={() => setIsProfileOpen(!isProfileOpen)}
                className="flex items-center space-x-3 p-2 rounded-lg hover:bg-teal-700 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <div className="relative">
                    <FaUserCircle className="w-8 h-8 text-teal-300" />
                    <div className="absolute bottom-0 right-0 w-2 h-2 bg-green-500 rounded-full border-2 border-teal-800"></div>
                  </div>
                  <div className="hidden lg:block text-left">
                    <p className="text-sm font-medium">
                      {loading ? 'Loading...' : adminData.email.split('@')[0]}
                    </p>
                    <p className="text-xs text-teal-300">
                      {loading ? 'Loading...' : adminData.role}
                    </p>
                  </div>
                  <FaChevronDown className={`text-sm transition-transform ${isProfileOpen ? 'rotate-180' : ''}`} />
                </div>
              </button>

              {/* Profile Dropdown Menu */}
              {isProfileOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-white text-gray-800 rounded-xl shadow-2xl z-50 border border-teal-100">
                <div className="p-4 border-b border-gray-100">
                  <div className="flex items-center space-x-3">
                    <div className="bg-gradient-to-r from-teal-100 to-emerald-100 w-12 h-12 rounded-full flex items-center justify-center">
                      <FaUserCircle className="text-2xl text-teal-600" />
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800">
                        {loading ? 'Loading...' : adminData.email.split('@')[0]}
                      </h4>
                      <p className="text-sm text-gray-600">
                        {loading ? 'Loading...' : adminData.email}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {loading ? 'Loading...' : `📱 ${adminData.mobileNumber}`}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-2">
                  <Link
                    to="/admin/profile"
                    className="flex items-center space-x-3 p-3 hover:bg-teal-50 rounded-lg transition-colors"
                    onClick={() => setIsProfileOpen(false)}
                  >
                    <FaUserCircle className="text-teal-600" />
                    <span className="font-medium text-gray-700">My Profile</span>
                  </Link>

                  <div className="border-t border-gray-200 my-2"></div>

                  {/* <button
                    onClick={handleLogout}
                    className="w-full flex items-center space-x-3 p-3 hover:bg-red-50 rounded-lg transition-colors text-red-600"
                   >
                    <FaSignOutAlt />
                    <span className="font-medium">Logout</span>
                  </button> */}
                </div>
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;